/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.compositeViewModule', ['foundationModule', 'bulbApp.ajaxModule', 'bulbApp.authorModule',
  'bulbApp.authModule', 'bulbApp.autoSaveModule', 'bulbApp.avatarImageModule', 'bulbApp.configModule', 'bulbApp.errorModule',
  'bulbApp.imageEditorModule', 'bulbApp.openGraphModule', 'bulbApp.permissionsModule',
  'bulbApp.shareModule', 'bulbApp.translateModule', 'bulbApp.unitModule', 'bulbApp.uploadModule', 'bulbApp.utilsModule']);
